var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 6.827 6.827",
    id: "Call",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.413,
    cy: 3.413,
    r: 3.413,
    fill: "#5367fc",
    className: "color837d6e svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M4.2703 4.02387l-0.314701 0.322181c-0.194894,-0.0970866 -1.16359,-0.614555 -1.50557,-1.46601l0.372051 -0.354819c0.0568268,-0.0541929 0.0748346,-0.124941 0.0677756,-0.196083 -0.0078189,-0.0787165 -0.0477205,-0.158366 -0.098437,-0.212921l8.66142e-005 -8.26772e-005c-0.00148031,-0.00159449 -0.00303937,-0.0030748 -0.00465748,-0.00445276l-0.621795 -0.614091 0.000106299 -0.000110236c-0.00275591,-0.00272441 -0.00572835,-0.00509055 -0.00886614,-0.0071063 -0.0357559,-0.0260472 -0.334437,-0.227094 -0.513839,0.188606 -0.0166378,0.0385512 -0.0362953,0.0772559 -0.0570551,0.11813 -0.19339,0.380764 -0.476764,0.938709 0.76335,2.42499l-7.08661e-005 5.90551e-005c0.00126772,0.00151575 0.00259843,0.00294488 0.00398819,0.00429134 0.0599528,0.068 1.01156,1.12615 2.25407,1.18098 0.111705,0.00492913 0.316228,-0.0671024 0.488484,-0.173673 0.0911142,-0.0563701 0.174587,-0.12289 0.232469,-0.19348 0.0639016,-0.0779252 0.0979291,-0.161846 0.0815512,-0.245713 -0.00850787,-0.0435748 -0.0304764,-0.0856575 -0.0686732,-0.125106l-0.641264 -0.662386 0.000110236 -0.000102362c-0.00312205,-0.00322835 -0.00655512,-0.00598819 -0.0101969,-0.00827559 -0.0342283,-0.0255945 -0.250169,-0.173823 -0.418917,0.0251693z",
    className: "colorffffff svgShape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.9e6622154e9c25fb792863ce7c3e9a0a.svg";
export { ForwardRef as ReactComponent };